import { createContext, useState, useEffect, useCallback } from "react";
import { getData } from "./Api";

export const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState(null);

    const fetchSettings = useCallback(async () => {
        try {
            const response = await getData(`/settings?t=${Date.now()}`);
            if (response.success) {
                setSettings(response.data);
            }
        } catch (error) {
            console.error("Error loading settings:", error);
        }
    }, []);

    useEffect(() => {
        // Fetch on initial mount
        fetchSettings();

        // Re-fetch whenever the user switches back to this browser tab
        // This handles: user changes toggle in admin tab → comes back to storefront tab
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                fetchSettings();
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [fetchSettings]);

    return (
        <SettingsContext.Provider value={{ settings }}>
            {children}
        </SettingsContext.Provider>
    );
};